import { useCookieWrapper } from './useCookieWrapper';

export const useCompareUtils = (activeList = {}) => {
  const { path, query } = useRoute();

  // Derived info from current path
  const isExplorePowderPage = path.startsWith('/explore/powder');
  const isFavorites = path.startsWith('/user/favorites');
  const parts = path.split('/');
  const view = parts[parts.length - 1];

  // Cookie names
  const lastComparePageCookieName = `lastcomparepage${isFavorites ? `-list-${activeList.id}` : ''}`;
  const mapSortCookieName = 'compare-map-sort';
  const sortCookieName = isExplorePowderPage
    ? 'explore-powder-sort'
    : `compare-${view}-sort`.toLowerCase();

  /**
   * Return computed object to manage sort and map sort cookies. The getter will read and return
   * the value of the specified cookie. And the setter will set the field and and current date when
   * saving the cookie. The caller may use the time the cookie was saved to determine whether to
   * sort by the specified field.
   */
  const getComputedObject = (cookieName) => {
    const cookie = useCookieWrapper(cookieName);

    return {
      get() {
        return cookie.value;
      },
      set(field) {
        cookie.value = { field, time: Date.now() };
      },
    };
  };

  // Cookies, computed props, and the compare field from the query
  const lastComparePageCookie = useCookieWrapper(lastComparePageCookieName);
  const mapSortCookie = computed(getComputedObject(mapSortCookieName));
  const sortCookie = computed(getComputedObject(sortCookieName));
  const queryCompareField = query.compare;

  return {
    lastComparePageCookie,
    mapSortCookie,
    sortCookie,
    queryCompareField,
  };
};
